import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const BENEFITS = ['Clases llenas todo el año gracias al Sistema Anti-Abandono que mantiene a tus alumnos motivados incluso en los meses difíciles', 'Inscripciones que llegan automáticamente con el Sistema Whatsapp que convierte las consultas en pagos sin parecer invasivo', 'Contenidos listos para publicar con 20+20 ideas de posteos ya escritos que atraen nuevos alumnos sin tener que pensar qué decir', 'Aumentos de precio sin perder gente gracias a la Escalera de Precios que te hace ganar más manteniendo a tus alumnos contentos', 'Posicionamiento claro y diferenciado que hace que te elijan justamente a vos, sin tener que competir solo por precio'];
export const ProductPresentation: React.FC = () => {
  return <section className="py-20 px-4 bg-white" data-id="element-223">
      <div className="container mx-auto max-w-5xl" data-id="element-224">
        <div className="text-center mb-12" data-id="element-225">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-226">
            Y es justamente por eso que creamos el...
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-227">
            Un sistema completo que te da todo lo necesario para tener clases
            llenas y alumnos fieles: contenidos ya listos, estrategias probadas,
            y un método paso a paso que realmente funciona.
          </p>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-3xl border border-blue-100 p-8 md:p-12 shadow-lg" data-id="element-228">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-229">
            {BENEFITS.map((benefit, index) => <div key={index} className={`bg-white rounded-2xl p-6 shadow-sm flex items-start gap-4 ${index === BENEFITS.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-230">
                <CheckCircle2Icon className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-231" />
                <p className="text-gray-800 font-medium leading-relaxed" data-id="element-232">
                  {benefit}
                </p>
              </div>)}
          </div>

          <p className="text-center italic text-gray-600 mt-10 text-lg" data-id="element-233">
            Todo lo que necesitás, listo para implementar hoy mismo.
          </p>
        </div>
      </div>
    </section>;
};